import { Component, OnInit } from '@angular/core';
import {FadeZoomInTop} from "../../animations/fade-zoom-in-top.decorator";

@Component({
  selector: 'app-external-layout',
  templateUrl: './external-layout.component.html',
  styles: []
})
export class ExternalLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
